import React from "react";
import styles from "./stories.module.css";
import Stories from "react-insta-stories";

const CareerStories = () => {
  const stories = [
    {
      url: "/images/carrer/image.png",
      type: "image",
    },
    {
      url: "/images/carrer/bg.png",
      type: "image",
    },
  ];

  return (
    <div className={styles.main_section}>
      <Stories
        stories={stories}
        defaultInterval={5000}
        loop={true}
        keyboardNavigation={true}
        progressContainerStyles={{
          position: "absolute",
          left: "0",
          width: "200px",
          height: "60px",
          borderRadius: "20px",
        }}
        progressStyles={{
          background: "orange",
          width: "100%",
          height: "100%",
        }}
      />
    </div>
  );
};

export default CareerStories;
